import React from 'react';
import { useLocation, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion/dist/framer-motion";
import Header from './components/partials/Header';
import Navbar from './components/partials/Navbar';
import Home from "./components/pages/HomeOutlet";
import ArchiveProjet from './components/pages/ProjectArchiveOutlet';
import ErrorPage from "./components/pages/ErrorPage";

const App = () => {

  const location = useLocation();
  const locationArr = location.pathname?.split('/') ?? [];
  

  return (
    <>

    <Header id="header" key="header"/>

      <AnimatePresence>

          <Routes location={location} key={locationArr[1]}> 
                    
            <Route exact path='/' element={<Home />} />
            
            <Route path='/projets/*' element={<ArchiveProjet />} />

            {/* <Route path='/projets/:id' element={<ArchiveProjet />} /> */}
              
            <Route path="*" element={<ErrorPage />} />

          </Routes>

      </AnimatePresence>

      <Navbar id="navbar" key="navbar" />

    </>
  );
};

export default App;